import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics';
import { FaEquals } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var EqualAddress = createPlugin({
    protocol: 'TOKEN_VALIDATOR',
    type: 'VALIDATOR',
    method: 'equalAddress',
    description: 'Check if amount1 is equal amount2',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                address1: new FctAddress({ isPreview: true, icon: FaEquals }),
                address2: new FctAddress({ isPreview: true }),
            },
        },
        output: {
            address1: new FctAddress({
                innerIndex: 0,
            }),
        },
    }); },
});
